import { positions } from "./constants";
import sanitizeColor from "./sanitizeColor";

const UID_KEY = "_monogram_uid";

function capitalize(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export default function handleAddToCart({
  product,
  currentVariantId,
  monogramVariant,
  config,
  setError,
}) {
  const isSide = config.position === positions.side;

  // Initial One: K
  // Initial Two: K
  // Font: MG Sans Serif w/ Shadow
  // Font Size: M
  // Text Color: Saddle
  // Shadow Color: Flamma

  // Initial One: M
  // Initial Two: S
  // Font: MG Script
  // Font Size: S
  // Text Color: Saddle

  // Initial One: T
  // Initial Two: C
  // Initial Three: P
  // Font: MG Script w/ Shadow
  // Font Size: S
  // Text Color: Rosa
  // Shadow Color: Blush

  // Initial Left: B
  // Initial Right: N
  // Font: MG Sans Serif w/ Shadow
  // Font Size: S
  // Position: Top
  // Text Color: Rosa
  // Shadow Color: Flamma

  const uid = window.crypto.randomUUID();

  let initialNames = ["_Initial One", "_Initial Two", "_Initial Three"];

  if (product.monogramSettings.mainPosition2 !== null && !isSide) {
    initialNames = ["_Initial Left", "_Initial Right"];
  }

  const properties = {};

  if (config.position) {
    properties["Placement"] = config.position;
  }

  properties["Letters"] = config.initials.join("");
  config.initials.forEach((initial, i) => {
    properties[initialNames[i]] = initial;
  });
  properties["Font"] = config.font.name;
  properties["Size"] = capitalize(config.size);
  properties["Color"] = sanitizeColor(config.color);

  if (config.shadowColor) {
    properties["Shadow Color"] = sanitizeColor(config.shadowColor);
  }

  properties["_finalSale"] = "true";
  properties[UID_KEY] = uid;

  const items = [
    {
      id: parseInt(currentVariantId),
      quantity: 1,
      properties,
    },
    {
      id: parseInt(monogramVariant),
      quantity: config.initials.filter((initial) => initial).length,
      properties: {
        [UID_KEY]: uid,
        Product: currentVariantId,
      },
    },
  ];

  window.addToCart(items, {
    onError: (response) => {
      setError(
        response?.message ||
          window.theme.localeStrings.product.add_to_cart_error,
      );
    },
    onAfterAdd: () => {
      document.dispatchEvent(new CustomEvent("mini-cart:open"));
    },
  });
}
